module.exports = __webpack_public_path__ + "static/media/calendar.fcfd2215.svg";